import React from "react";
import { useSelector } from "react-redux";

export const CartIcon = (props) => {
    const itemCount = useSelector(state => state.cart.itemCount);
    return <div onClick={props.onClick} className="icon-wrap">
        <div class="icon-cart">
            <svg width="25px" height="24px" viewBox="0 0 25 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
            <defs>
                <polygon id="path-1" points="0 5.25750656 0.610107422 1.52408854 3 0 6.69555664 0 9 3.48632812 9 8 0 8"></polygon>
            </defs>
            <g id="Web-(mobile)" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Category-Page" transform="translate(-380.000000, -17.000000)">
                    <g id="Cart-icon" transform="translate(10.000000, 15.000000)">
                        <g transform="translate(370.139226, 2.500000)">
                            <rect id="Rectangle" fill="#1C1A1A" x="0.860773856" y="20.4544674" width="23" height="2" rx="1"></rect>
                            <rect id="Rectangle" fill="#1C1A1A" x="2.16077386" y="8" width="20.3" height="2" rx="1"></rect>
                            <path d="M0.869163266,21.3187529 L2.13844734,9.44755113 C2.19768238,8.89354505 2.68508222,8.48599854 3.24082381,8.5257829 C3.77205291,8.56381246 4.17187013,9.02528777 4.13384057,9.55651687 C4.13303604,9.56775528 4.13203461,9.57897872 4.13083673,9.59018203 L2.86155266,21.4613838 C2.80231762,22.0153898 2.31491778,22.4229363 1.75917619,22.383152 C1.22794709,22.3451224 0.828129869,21.8836471 0.866159426,21.352418 C0.86696396,21.3411796 0.867965394,21.3299562 0.869163266,21.3187529 Z" id="Rectangle" fill="#1C1A1A"></path>
                            <path d="M22.5465008,9.44755113 L23.8157848,21.3187529 C23.8724072,21.848323 23.4890072,22.3235258 22.9594371,22.3801482 C22.9482338,22.381346 22.9370103,22.3823475 22.9257719,22.383152 C22.3700303,22.4229363 21.8826305,22.0153898 21.8233954,21.4613838 L20.5541114,9.59018203 C20.4974891,9.06061191 20.880889,8.58540905 21.4104591,8.52878674 C21.4216624,8.52758887 21.4328859,8.52658743 21.4441243,8.5257829 C21.9998659,8.48599854 22.4872657,8.89354505 22.5465008,9.44755113 Z" id="Rectangle" fill="#1C1A1A"></path>
                            <g id="Oval-2" transform="translate(7.860774, 0.000000)">
                                <mask id="mask-2" fill="white">
                                    <use href="#path-1"></use>
                                </mask>
                                <g id="Path-2"></g>
                                <ellipse id="Oval" stroke="#000000" strokeWidth="2" mask="url(#mask-2)" cx="4.5" cy="8.25" rx="3.5" ry="4.75"></ellipse>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        {itemCount > 0 && <span className="icon-cart-count">{itemCount}</span>}
    </div>
    {props.children}
    </div>;
}

export const MenuIcon = (props) => {
    return <div onClick={props.onClick} className="icon-wrap">
        <svg width="23px" height="19px" viewBox="0 0 23 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink">
            <g id="Web-(mobile)" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Category-Page" transform="translate(-10.000000, -18.000000)" fill="#1C1A1A">
                    <g id="Group-2" transform="translate(10.000000, 15.000000)">
                        <g transform="translate(0.000000, 3.000000)">
                            <rect id="Rectangle" x="0" y="0" width="23" height="3" rx="1.5"></rect>
                            <rect id="Rectangle" x="0" y="8" width="18" height="3" rx="1.5"></rect>
                            <rect id="Rectangle" x="0" y="16" width="23" height="3" rx="1.5"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        {props.children}
    </div>;
}

export const SearchIcon = (props) => {
    return <div onClick={props.onClick} className="icon-wrap mobile-only">
        <svg width="17px" height="21px" viewBox="0 0 17 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink">
            <g id="Web-(mobile)" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Category-Page" transform="translate(-343.000000, -20.000000)">
                    <g id="Search-icon" transform="translate(10.000000, 15.000000)">
                        <g transform="translate(334.000000, 6.000000)">
                            <circle id="Oval" stroke="#1C1A1A" strokeWidth="2" cx="6.5" cy="6.5" r="6.5"></circle>
                            <rect id="Rectangle" fill="#1C1A1A" transform="translate(11.947384, 15.182463) rotate(-303.000000) translate(-11.947384, -15.182463) " x="7.44738403" y="13.8074629" width="9" height="2.75" rx="1.375"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        {props.children}
    </div>;
}